const isQERP = url => {
  if (url.includes('qerp')) return true;
  if (url.includes('terp')) return false;
  return true;
};

export default isQERP;
